import { Box, CssBaseline } from "@mui/material";
import React from "react";
import { Outlet } from "react-router-dom";

const SecondaryLayout = () => {
  return (
    <>
      <CssBaseline />
      <Box
        sx={{
          display: "flex",
          minHeight: "100vh",
          width: "100vw",
          position: "relative",
          overflow: "hidden",
          alignItems: "center",
          justifyContent: "center",
          p: { xs: 2, md: 4 },
          background: "linear-gradient(135deg, #0f172a 0%, #1e1b4b 100%)", // Pure dark gradient background
        }}
      >
        {/* Dynamic lighting effects to maintain depth without the image */}
        <Box sx={{
          position: "absolute",
          top: "-15%",
          left: "20%",
          width: "50vw",
          height: "50vw",
          background: "radial-gradient(circle, rgba(99, 102, 241, 0.12) 0%, transparent 70%)",
          filter: "blur(80px)",
          zIndex: 0,
        }} />
        <Box sx={{
          position: "absolute",
          bottom: "-10%",
          right: "10%",
          width: "45vw",
          height: "45vw",
          background: "radial-gradient(circle, rgba(139, 92, 246, 0.08) 0%, transparent 70%)",
          filter: "blur(60px)",
          zIndex: 0,
        }} />

        {/* Subtle mesh pattern for texture */}
        <Box sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `radial-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px)`,
          backgroundSize: "30px 30px",
          zIndex: 0
        }} />

        {/* Main Content (The Login Card) */}
        <Box sx={{
          position: "relative",
          zIndex: 1,
          width: "100%",
          maxWidth: 1200,
          animation: "fadeIn 0.8s ease-out"
        }}>
          <Outlet />
        </Box>

        <style>{`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}</style>
      </Box>
    </>
  );
};

export default SecondaryLayout;
